import { editorLogin as renderLogin, type EditorLoginProps } from '@adornis/web-editor/client/EditorLogin.js';
export const editorLogin = (props: EditorLoginProps) => renderLogin({ ...props, title: 'Viva Porta Editor' });
